import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Booking = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2001 3.60004H4.8001C4.13736 3.60004 3.6001 4.13729 3.6001 4.80004V19.2C3.6001 19.8628 4.13736 20.4 4.8001 20.4H19.2001C19.8628 20.4 20.4001 19.8628 20.4001 19.2V4.80004C20.4001 4.13729 19.8628 3.60004 19.2001 3.60004Z"
        stroke={color || tailwindConfig.theme.colors.black}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3201 10.2L13.9801 8.49604C13.929 8.45514 13.8655 8.43286 13.8001 8.43286C13.7346 8.43286 13.6711 8.45514 13.6201 8.49604L11.2801 10.2C11.2347 10.2341 11.1805 10.2547 11.1239 10.2592C11.0674 10.2638 11.0106 10.2522 10.9604 10.2258C10.9101 10.1995 10.8683 10.1593 10.84 10.1102C10.8116 10.061 10.7977 10.0048 10.8001 9.94804V3.60004H16.8001V9.94804C16.8024 10.0048 16.7885 10.061 16.7601 10.1102C16.7318 10.1593 16.69 10.1995 16.6398 10.2258C16.5895 10.2522 16.5328 10.2638 16.4762 10.2592C16.4196 10.2547 16.3654 10.2341 16.3201 10.2Z"
        stroke={color || tailwindConfig.theme.colors.black}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default Booking;
